export default function SettingsLayout({
  children,
  scrollContainerRef
}) {
  return (
    <div ref={scrollContainerRef} className="flex-1 overflow-y-auto px-4 md:px-10 py-6 bg-surface pretty-scroll">
      <div className="max-w-2xl mx-auto space-y-8">
        {children}
      </div>
    </div>
  );
}
